import React from 'react';
import Input from 'components/forms/Input';
import PropTypes from 'prop-types';
import Error from 'components/forms/Error';

const RenderFormInput = ({
  input,
  label,
  type,
  name,
  autocomplete,
  min,
  max,
  step,
  className,
  disabled,
  lpignore,
  leftIcon,
  noBorder,
  multiline,
  meta: { touched, error },
}) => (
  <React.Fragment>
    <Input
      leftIcon={leftIcon}
      noBorder={noBorder}
      multiline={multiline}
      inputProps={{
        ...input,
        className: `${className} form-control`,
        name,
        min,
        max,
        step,
        placeholder: label,
        type,
        disabled,
        autoComplete: autocomplete,
        'data-lpignore': lpignore,
      }}
    />
    {touched && ((error && <Error error={error} />))}
  </React.Fragment>
);

RenderFormInput.propTypes = {
  input: PropTypes.shape({}).isRequired,
  label: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  leftIcon: PropTypes.string,
  autocomplete: PropTypes.string,
  min: PropTypes.string,
  max: PropTypes.string,
  step: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  lpignore: PropTypes.bool,
  meta: PropTypes.shape({
    touched: PropTypes.bool.isRequired,
    error: PropTypes.string.isRequired,
  }).isRequired,
  noBorder: PropTypes.bool,
  multiline: PropTypes.bool,
};

RenderFormInput.defaultProps = {
  label: null,
  type: null,
  name: null,
  autocomplete: null,
  min: null,
  max: null,
  step: null,
  className: null,
  disabled: false,
  lpignore: null,
  leftIcon: null,
  noBorder: false,
  multiline: false,
};

export default RenderFormInput;
